import { useAct } from 'FlowBuilder/store'
import Checkbox from 'Shared/components/Checkbox'
import InlineCkEditor from 'Shared/components/CKEditor/InlineCkEditor'
import AsyncSelect from 'Shared/components/AsyncSelect'
import LiquidValidator from 'Shared/components/LiquidValidator/LiquidValidator'
import { startCase } from 'Shared/functions/util'
import shareLinkMergeTags from './shareLinkMergeTags'
import './ThankYouEmailSettingsForm.scoped.scss'
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate'

export default function ThankYouEmailSettingsForm({ actionId, additionalMergeTags = {} }) {
  const act = useAct()

  const action = useSel(s => s.actions.entities[actionId])
  const config = action.config || { thankYouSubject: '', thankYouSenderId: '', thankYouEnabled: false }
  const [sourceMode, setSourceMode] = useState(false)
  const globalMergeTags = useSel(s => s.builder.mergeTags)
  const mergeTags = {...globalMergeTags, ...additionalMergeTags, ...shareLinkMergeTags}

  const {
    language,
    translated: { thankYouSubject, thankYouBody },
    fallback: { thankYouSubject: thankYouSubjectFallback, thankYouBody: thankYouBodyFallback },
    textContentUpdater,
    flag
  } = useActionTranslate({ actionId })

  function updateActionConfig(data) {
    act.actions.upsert(actionId, { config: { ...config, ...data } })
  }

  return <>
    <h2 className='no-margin-top'>
      { startCase(action.kind.replace(/_/g, ' ')) } Thank You Responder
    </h2>
    <div className="flex column gap-10 no-margin-bottom">
      <div className='field'>
        <Checkbox
          label="Enabled"
          className="no-margin-bottom"
          checked={config.thankYouEnabled}
          onChange={(e) => updateActionConfig({ thankYouEnabled: e.target.checked})}
        />
      </div>
      <div className={'field' + (config.thankYouEnabled && !config.thankYouSenderId ? ' invalid' : '')}>
        <label className="bold margin-bottom ">Sender</label>
        <AsyncSelect
          entity="email_sender"
          value={config.thankYouSenderId}
          onChange={value => updateActionConfig({ thankYouSenderId: value })}
          classNamePrefix="email-sender-select"
          disabled={!config.thankYouEnabled}
        />
      </div>
      <div className={'field' + (config.thankYouEnabled && !thankYouSubjectFallback ? ' invalid' : '')}>
        <label className="bold">Subject {flag}</label>
        <input type='text' className='full-width margin-top' value={thankYouSubject ?? ''} onChange={(e) => textContentUpdater('thankYouSubject', e.target.value)} disabled={!config.thankYouEnabled} placeholder={thankYouSubjectFallback}/>
      </div>
      <div className={'field' + (config.thankYouEnabled && !thankYouBodyFallback ? ' invalid' : '')}>
        <label className="bold">Body {flag}</label>
        <InlineCkEditor
          value={thankYouBody ?? ''}
          sourceMode={sourceMode}
          setSourceMode={setSourceMode}
          onUpdate={value => textContentUpdater('thankYouBody', value )}
          placeholder={thankYouBodyFallback}
          mergeTags={mergeTags}
          disabled={!config.thankYouEnabled}
        />
        <LiquidValidator value={config.thankYouBody} lineSplitTags={!sourceMode} availableTags={mergeTags} />
      </div>
    </div>
  </>
}
